<!--
 * @Author: 曹捷
 * @Date: 2021-01-08 10:51:15
 * @LastEditors: 曹捷
 * @LastEditTime: 2022-07-05 17:00:11
 * @Description: fileContent
-->
<template>
  <a-config-provider :locale="locale" :autoInsertSpaceInButton="false" v-if="loading">
    <!-- <router-view class="theme-blue theme-default" /> -->
    <!---登录和主页等没有layout--->
    <!-- <router-view v-if="!showLayout" /> -->
    <layout>
    </layout>
  </a-config-provider>
</template>

<script>

import layout from './layout/layout.vue'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import hook from 'obit-wui/hook'
import { util } from 'obit-wui'
import { provide, watch, ref, getCurrentInstance, reactive, toRefs } from 'vue'
import { useRoute } from "vue-router"
// import {ConfigProvider} from 'ant-design-vue'
export default {
  components: { layout },
  setup () {
    let { proxy } = getCurrentInstance()
    let _data = reactive({
      loading: false
    })
    provide('http', proxy.$http)
    provide('util', util)
    provide('hook', hook)
    const showLayout = ref(false);
    const route = useRoute();
    let methods = {
      async initEnv () {
        let ENV = await proxy.$http.basePost('system/config/getFrontStyle')
        sessionStorage.setItem('SENV', ENV)
        _data.loading = true
      }
    }
    methods.initEnv()

    return {
      showLayout,
      ...toRefs(_data),
      locale: zhCN
    }
  }
}

</script>

<style>
#mainApp {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
</style>